export default __webpack_public_path__ + "static/media/Point 2 Icon.924f556a.svg";